import {
  LocalVideo,
  MeetingStatus,
  useLocalVideo,
  useMeetingStatus,
  useToggleLocalMute
} from 'amazon-chime-sdk-component-library-react'
import { ParticipantBadge } from '@components/atoms/ParticipantBadge/ParticipantBadge'
import { SpeakingIndicator } from '@components/atoms/SpeakingIndicator/SpeakingIndicator'
import { useLocalUserSpeaking } from '@hooks/useLocalUserSpeaking'
import { useLocalParticipantInitials } from '@hooks/useLocalParticipantInitials'
import { VIDEO_CLASSES } from '@constants/meetingLayout'

/**
 * Full-screen local video component
 * Used when the user is alone in the meeting
 */
export const LocalVideoFullScreen = () => {
  const { isVideoEnabled } = useLocalVideo()
  const isLocalSpeaking = useLocalUserSpeaking()
  const status = useMeetingStatus()
  const { initials, firstName } = useLocalParticipantInitials()
  const { muted } = useToggleLocalMute()

  return (
    <div className="absolute inset-0 h-full w-full">
      {/* Video or avatar */}
      <div className="absolute inset-0 flex items-center justify-center">
        {isVideoEnabled && status === MeetingStatus.Succeeded ? (
          <LocalVideo className={`${VIDEO_CLASSES.fullCover} ${VIDEO_CLASSES.videoElement}`} />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-surface-dark">
            <SpeakingIndicator isSpeaking={isLocalSpeaking && !isVideoEnabled} size="lg">
              <div className="flex h-32 w-32 items-center justify-center rounded-full bg-surface-medium">
                <span className="text-6xl font-bold text-primary">{initials}</span>
              </div>
            </SpeakingIndicator>
          </div>
        )}
      </div>

      {/* Participant badge */}
      <ParticipantBadge name={firstName} position="bottom-left" isMuted={muted} />
    </div>
  )
}
